export default __webpack_public_path__ + "static/media/maintenance.baa8f675.svg";